import { Injectable } from '@angular/core';
import { FirestoreService } from '../firebase/firestore.service';
import { StudentMetadataForClass, StudentMetadataForClassSnapShot } from './store/students.model';
import { ActionLoadStudentMetadataForClass } from './store/students.actions';
import { map, switchMap } from 'rxjs/operators';
import { of, from } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StudentsDataService {

    constructor(private firestoreService: FirestoreService) { }

    createStudentMetadataForClassDocument(
            studentMetadataForClass: StudentMetadataForClassSnapShot
        ): StudentMetadataForClass {
        return {
            ...studentMetadataForClass as any,
            id: this.firestoreService.generateId('students')
        };
    }

    insertStudentMetadataForClass(studentMetadataForClass: StudentMetadataForClass) {
        return from(this.firestoreService.setDoc(this.firestoreService.doc('students', studentMetadataForClass.id), studentMetadataForClass));
    }

    updateStudentMetadataForClass(updatedStudentMetadataForClass: StudentMetadataForClassSnapShot) {
        return from(this.firestoreService.updateDoc(this.firestoreService.doc('students', updatedStudentMetadataForClass.id),
            updatedStudentMetadataForClass as { [key: string]: any }));
    }

    fetchStudentMetadataForClass(classId: string, createdBy: string) {
        const q = this.firestoreService.query(
            this.firestoreService.collection('students'),
            this.firestoreService.where('classId', '==', classId),
            this.firestoreService.where('createdBy', '==', createdBy)
        );
        return this.firestoreService.collectionSnapshots(q).pipe(
            map(snapshots => snapshots.map(snapshot => {
                const data = snapshot.data() as StudentMetadataForClass;
                const id = snapshot.id;
                return { ...data, id };
            })),
            switchMap((studentMetadataForClass) => {
                return of(new ActionLoadStudentMetadataForClass({ studentMetadataForClass }));
            })
        );
    }
}
